/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_DescriptionInputs */

const en_directory_integrate_description = /** @type {(inputs: Directory_Integrate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore models, manage account access, and search the public directory from the tools already available in Seek AI.`)
};

const zh_directory_integrate_description = /** @type {(inputs: Directory_Integrate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过 Seek AI 已经可用的工具探索模型、管理账户访问并搜索公开目录。`)
};

/**
* | output |
* | --- |
* | "Explore models, manage account access, and search the public directory from the tools already available in Seek AI." |
*
* @param {Directory_Integrate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_description = /** @type {((inputs?: Directory_Integrate_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_description(inputs)
	return zh_directory_integrate_description(inputs)
});
export { directory_integrate_description as "directory.integrate.description" }